// import actions
import sedeAction from './actions/sede'
import ubigeoAction from './actions/ubigeo'

// import getters
import sedeGetter from './getters/sede'

// import mutations
import sedeMutation from './mutations/sede'

// import states
import sedeState from './states/sede'

const actions = { ...sedeAction, ...ubigeoAction }

const getters = { ...sedeGetter }

const mutations = { ...sedeMutation }

const state = { ...sedeState }

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
